<mat-card-title>
	Enrollment Report
	<help-text-btn class="align-help-text-btn" [helpTextId]="'EnrollmentReport_Overview'"></help-text-btn>
</mat-card-title>
<p style="line-height:0px;">&nbsp;</p>
<mat-divider> </mat-divider>
<br>
<div>
	<mat-card appearance="outlined">
		<div class="row gx-0">
			<div class="col-lg-6">
				<mat-card-header>
					<mat-card-title>
						Search Criteria
					</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<region-dropdown-two-way [isMultiple]="false" [(selectedRegions)]="chosenRegions"
						[reset]="resetField" [required]="true" #appRegionCode>
					</region-dropdown-two-way>

					<county-dropdown-two-way [isMultiple]="false" [(selectedCounties)]="chosenCounties"
						[reset]="resetField" [required]="true" #appCountyCode [regions]="chosenRegions">
					</county-dropdown-two-way>

					<district-dropdown-two-way [isMultiple]="false" [(selectedSchoolDistricts)]="chosenSchoolDistricts"
						[reset]="resetField" [required]="true" #appSchoolDistrictCode [regions]="chosenRegions"
						[counties]="chosenCounties">
					</district-dropdown-two-way>

					<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools"
						[reset]="resetField" #appSchoolsCode [regions]="chosenRegions" [counties]="chosenCounties"
						[schoolDistricts]="chosenSchoolDistricts">
					</school-dropdown-two-way>

					<app-school-year [yearType]="'SchoolYear'" (performancePeriodEvent)="performancePeriodEvent($event)"
						[reset]="resetField" [required]="true">
					</app-school-year>
				</mat-card-content>
				<mat-card-header>
					<mat-card-title>
						Enrollment Type *
						<help-text-btn class="align-help-text-btn" [helpTextId]="'EnrollmentType'"></help-text-btn>
					</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<div class="row">
						<mat-checkbox [color]="'primary'" [(ngModel)]="rAttending">
							Regular School Year - Attending</mat-checkbox>
						<mat-checkbox [color]="'primary'" [(ngModel)]="rNotAttending">
							Regular School Year - Not Attending</mat-checkbox>
					</div>
				</mat-card-content>

				<mat-card-header>
					<mat-card-title>
						Additional Fields
						<help-text-btn class="align-help-text-btn"
							[helpTextId]="'EnrollmentReport_AdditionalFields'"></help-text-btn>
					</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<div class="row">
						<mat-form-field appearance="fill">
							<mat-label>Select Columns</mat-label>
							<mat-select [multiple]="true" (selectionChange)="checkbox($event.value, columns)"
								[(ngModel)]="selectedColumns" [panelClass]="'panel-500'">

								<div class="padding-md text-center row">
									<div class="col-lg-6">
										<button color="primary" mat-raised-button (click)="selectAllColumns(columns)">
											Select All
										</button>
									</div>
									<div class="col-lg-6">
										<button color="accent" mat-raised-button (click)="deSelectAllColumns(columns)">
											Deselect All
										</button>
									</div>
								</div>

								<mat-option [value]="column.key"
									*ngFor="let column of columns | keyvalue | orderBy: 'value.INDEX'"
									[disabled]="column.value.DISABLED">
									{{column.key}}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</mat-card-content>
			</div>
			<div class="col-lg-6">
				<mat-card-header>
					<mat-card-title>
						Filters
						<help-text-btn class="align-help-text-btn"
							[helpTextId]="'EnrollmentReport_Filters'"></help-text-btn>
					</mat-card-title>
				</mat-card-header>

				<mat-card-content>
					<div class="row">
						<mat-checkbox [color]="'primary'" [(ngModel)]="expiredEligibility">
							Include children without Eligibility in Period (EiP)</mat-checkbox>
						<mat-checkbox [color]="'primary'" [(ngModel)]="expiredQAD">
							Include children with expired QAD</mat-checkbox>
						<mat-checkbox [color]="'primary'" [(ngModel)]="notWithdrawnFromSchool">
							Only include children without a withdrawal date</mat-checkbox>
						<mat-checkbox [color]="'primary'" [(ngModel)]="k12Ungraded">
							Only include children in grades K-12</mat-checkbox>
						<mat-checkbox [color]="'primary'" [(ngModel)]="verifiedCoes">
							Only include children on verified COEs</mat-checkbox>
					</div>
					<div class="row">
						<hr />
						<mat-radio-group [(ngModel)]="chosenCriterionFilter" class="row">
							<mat-radio-button [color]="'primary'" #criterionFilterButton
								*ngFor="let criterionFilter of criterionFilters | keyvalue"
								[value]="criterionFilter.value.DATA"
								(click)="checkCriterionFilter($event, criterionFilterButton)">
								{{criterionFilter.key}}

								<span *ngIf="chosenCriterionFilter === criterionFilter.value.DATA"
									class="theme-font-color bold">
									<span *ngIf="criterionStartDate && !criterionEndDate"> on or after </span>
									<span *ngIf="!criterionStartDate && criterionEndDate"> on or before </span>
									<span *ngIf="criterionStartDate && criterionEndDate"> between </span>

									<span *ngIf="criterionStartDate">{{criterionStartDate | simpleDate}}</span>
									<span *ngIf="criterionStartDate && criterionEndDate"> to </span>
									<span *ngIf="criterionEndDate">{{criterionEndDate | simpleDate}}</span>
								</span>
							</mat-radio-button>
						</mat-radio-group>

						<div class="row margin-top-sm">
							<mat-form-field class="col-lg-6">
								<mat-label>Start Date</mat-label>
								<input matInput [matDatepicker]="criterionStartDatePicker"
									[(ngModel)]="criterionStartDate" [disabled]="!chosenCriterionFilter">
								<mat-datepicker-toggle matSuffix
									[for]="criterionStartDatePicker"></mat-datepicker-toggle>
								<mat-datepicker #criterionStartDatePicker></mat-datepicker>
							</mat-form-field>


							<mat-form-field class="col-lg-6">
								<mat-label>End Date</mat-label>
								<input matInput [matDatepicker]="criterionEndDatePicker" [(ngModel)]="criterionEndDate"
									[disabled]="!chosenCriterionFilter">
								<mat-datepicker-toggle matSuffix [for]="criterionEndDatePicker"></mat-datepicker-toggle>
								<mat-datepicker #criterionEndDatePicker></mat-datepicker>
							</mat-form-field>
						</div>
					</div>
					<div class="row">
						<hr />

						<mat-checkbox [color]="'primary'" [(ngModel)]="recruitedSince">
							Recruited
							<span *ngIf="recruitedSince" class="theme-font-color bold">
								<span *ngIf="recruitedSinceStartDate && !recruitedSinceEndDate"> on or after </span>
								<span *ngIf="!recruitedSinceStartDate && recruitedSinceEndDate"> on or before </span>
								<span *ngIf="recruitedSinceStartDate && recruitedSinceEndDate"> between </span>

								<span *ngIf="recruitedSinceStartDate">{{recruitedSinceStartDate | simpleDate}}</span>
								<span *ngIf="recruitedSinceStartDate && recruitedSinceEndDate"> to </span>
								<span *ngIf="recruitedSinceEndDate">{{recruitedSinceEndDate | simpleDate}}</span>
							</span>
						</mat-checkbox>

						<div class="row margin-top-sm">
							<mat-form-field class="col-lg-6">
								<mat-label>Start Date</mat-label>
								<input matInput [matDatepicker]="recruitedSinceStartDatePicker"
									[(ngModel)]="recruitedSinceStartDate" [disabled]="!recruitedSince">
								<mat-datepicker-toggle matSuffix [for]="recruitedSinceStartDatePicker">
								</mat-datepicker-toggle>
								<mat-datepicker #recruitedSinceStartDatePicker></mat-datepicker>
							</mat-form-field>


							<mat-form-field class="col-lg-6">
								<mat-label>End Date</mat-label>
								<input matInput [matDatepicker]="recruitedSinceEndDatePicker"
									[(ngModel)]="recruitedSinceEndDate" [disabled]="!recruitedSince">
								<mat-datepicker-toggle matSuffix [for]="recruitedSinceEndDatePicker">
								</mat-datepicker-toggle>
								<mat-datepicker #recruitedSinceEndDatePicker></mat-datepicker>
							</mat-form-field>
						</div>
					</div>
				</mat-card-content>
			</div>
		</div>
		<mat-card-actions>
			<button mat-raised-button color="primary" mat-button [disabled]="!this.checkValid() || isLoading"
				(click)="search()" class="margin-right-xs">
				<mat-icon *ngIf="isLoading">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Search
			</button>
			<button mat-raised-button color="accent" (click)="reset()" mat-button class="margin-right-xs">Reset</button>
			<button [disabled]="!(results.length > 0) || isExporting" mat-raised-button [matMenuTriggerFor]="menu"
				class="margin-right-xs">
				<mat-icon *ngIf="isExporting">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Export
				<mat-icon *ngIf="!isExporting">more_vert</mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				<button mat-menu-item (click)="downloadExcel()">
					<span>
						<i class="fa fa-file"></i>
						Export to Excel</span>
				</button>
				<button mat-menu-item (click)="downloadCSV()">
					<span>
						<i class="fa fa-file"></i>
						Export to CSV</span>
				</button>
				<!-- <button mat-menu-item (click)="downloadPDF()">
					<span>
						<i class="fa fa-file"></i>
						Export PDF</span>
				</button>		 -->
			</mat-menu>
		</mat-card-actions>
	</mat-card>
</div>

<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

<div *ngIf="results.length > 0" class="margin-top-md">
	<div class="h5">
		Enrollment Report - {{studentLength}} Child(ren) {{'(' + currentSchoolYear + ')'}}

		<button class="pull-right" mat-button [matMenuTriggerFor]="tableControlMenu">
			<mat-icon>menu</mat-icon>
		</button>

		<mat-menu #tableControlMenu="matMenu">
			<button mat-menu-item (click)="expandAll(regions)">
				<span>
					Expand All
				</span>
			</button>
			<button mat-menu-item (click)="collapseAll(regions)">
				<span>
					Collapse All
				</span>
			</button>
		</mat-menu>

	</div>
	<hr />

	<div class="row">
		<mat-form-field class="col-lg-12">
			<mat-label>
				Filter
			</mat-label>
			<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
				(ngModelChangeDebounced)="setFilter();" />
		</mat-form-field>
	</div>

	<div *ngFor="let region of regions" class="margin-top-sm">
		<h3>
			<span class="bold">Region {{region.CODE}} - {{region.NAME}}
				[{{region.countyLength}} County(s), {{region.schoolDistrictLength}} School District(s),
				{{region.schoolLength}} School(s), {{region.studentLength}} Child(ren), {{region.enrollmentLength}}
				Enrollment(s)]</span>
		</h3>
		<div *ngFor="let county of region.COUNTIES">
			<h3>
				<span class="underline">County {{county.COUNTY_CODE}} - {{county.COUNTY_NAME}}
					[{{county.schoolDistrictLength}} School District(s), {{county.schoolLength}} School(s),
					{{county.studentLength}} Child(ren), {{county.enrollmentLength}} Enrollment(s)]</span>
			</h3>
			<div *ngFor="let schoolDistrict of county.SCHOOL_DISTRICTS" class="margin-left-md">
				<h3>
					<span class="cursor-pointer" (click)="toggleShow(schoolDistrict)">{{schoolDistrict.DISTRICTS}}
						[{{schoolDistrict.schoolLength}} School(s), {{schoolDistrict.studentLength}} Child(ren),
						{{schoolDistrict.enrollmentLength}} Enrollment(s)]</span>

					<mat-icon class="v-align-middle cursor-pointer" [color]="schoolDistrict.SHOW ? 'primary' : ''"
						(click)="toggleShow(schoolDistrict)">
						{{schoolDistrict.SHOW ? 'expand_more' : 'chevron_right'}}
					</mat-icon>
				</h3>
				<ul *ngFor="let cur of schoolDistrict.SCHOOLS; let i = index" [hidden]="!schoolDistrict.SHOW"
					class="margin-left-md margin-bottom-sm">
					<li>
						<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.NAME}} [{{cur.studentLength}}
							Child(ren), {{cur.enrollmentLength}} Enrollment(s)]</span>

						<span class="cursor-pointer" (click)="toggleShow(cur)"> {{'(' + (filter.length
							=== 0 ? '' : tableDataSources[i]?.filteredData?.length + '/') + cur.STUDENTS!.length +
							')'}}</span>

						<mat-icon class="v-align-middle cursor-pointer" [color]="cur.SHOW ? 'primary' : ''"
							(click)="toggleShow(cur)">
							{{cur.SHOW ? 'expand_more' : 'chevron_right'}}
						</mat-icon>
					</li>

					<div class="table-responsive">
						<mat-table [dataSource]="tableDataSources[i]" matSort
							(matSortChange)="announceSortChange($event)"
							[hidden]="!cur.SHOW || tableDataSources[i]?.filteredData?.length === 0">
							<ng-container matColumnDef="CODE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Region </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{region.CODE}} </mat-cell>
							</ng-container>
							<ng-container matColumnDef="COUNTY_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> County </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{county.COUNTY_NAME}} </mat-cell>
							</ng-container>

							<ng-container matColumnDef="DISTRICTS">
								<mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{schoolDistrict.DISTRICTS}} </mat-cell>
							</ng-container>

							<ng-container matColumnDef="NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{cur.NAME}} </mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_YEAR">
								<mat-header-cell *matHeaderCellDef mat-sort-header> School Year </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{cur.SCHOOL_YEAR}} </mat-cell>
							</ng-container>

							<ng-container matColumnDef="CDS_CODE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> School CDS Code </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{cur.CDS_CODE}} </mat-cell>
							</ng-container>

							<ng-container matColumnDef="MSD_NUMBER">
								<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									<edit-child-modal-btn [studentId]="element.ID" [type]="'string'"
										[displayText]="element.MSD_NUMBER">
									</edit-child-modal-btn>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SSID">
								<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{element.SSID}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="MSIX">
								<mat-header-cell *matHeaderCellDef mat-sort-header> MSIX </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{element.MSIX}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SISID[0].IDENTIFIER_VALUE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> SIS ID </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sisid of element.SISID">{{sisid.IDENTIFIER_VALUE}}</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="PERSON.LAST_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{element.PERSON.LAST_NAME |
									titlecase}}{{(element.SECOND_LAST_NAME
									? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}}
									{{element.PERSON.FIRST_NAME |
									titlecase}}
									{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="DOB">
								<mat-header-cell *matHeaderCellDef mat-sort-header> DOB </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{element.DOB | simpleDate}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="AGE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Age </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{element.AGE}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SEX">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Gender </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{element.SEX}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="HEALTH_NOTE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Medical Alert </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{element.HEALTH_NOTE}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="PREFERRED_EMAIL.EMAIL_ADDRESS">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Child's Preferred Email
								</mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{element.PREFERRED_EMAIL?.EMAIL_ADDRESS}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="PREFERRED_PHONE.PHONE_NUMBER">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Child's Preferred Phone Number
								</mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{element.PREFERRED_PHONE?.PHONE_NUMBER}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="RACE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Ethnicity </mat-header-cell>
								<mat-cell *matCellDef="let element" [ngClass]="{'selected': isSelected(element)}">
									{{element.RACE}}</mat-cell>
							</ng-container>

							<ng-container
								matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.COE_NUMBER">
								<mat-header-cell *matHeaderCellDef mat-sort-header> COE Number </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
										{{sed.STUDENT_ELIGIBILITIES[0].CO.COE_NUMBER}}</div>
								</mat-cell>
							</ng-container>

							<ng-container
								matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.COE_STATUSES[0].COE_STATUS_TYPES.TYPE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> COE Verified </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
										{{sed.STUDENT_ELIGIBILITIES[0].CO.COE_STATUSES[0].COE_STATUS_TYPES.TYPE}}</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].GRADE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.GRADE}}</div>
								</mat-cell>
							</ng-container>

							<ng-container
								matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.QUALIFYING_ARRIVAL_DATE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> QAD </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
										{{sed.STUDENT_ELIGIBILITIES[0].CO.QUALIFYING_ARRIVAL_DATE | simpleDate}}</div>
								</mat-cell>
							</ng-container>

							<ng-container
								matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> EoE </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
										{{sed.STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE | simpleDate}}</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].expiredEligibility">
								<mat-header-cell *matHeaderCellDef mat-sort-header> EoE Flag </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
										{{sed.expiredEligibility ? 'Y' : ''}}</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].EoEToday">
								<mat-header-cell *matHeaderCellDef mat-sort-header> EoE Now Flag </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
										{{sed.EoEToday ? 'Y' : ''}}</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].RECRUITER_SIGN_DATE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Recruiter Sign Date
								</mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.RECRUITER_SIGN_DATE
										|
										simpleDate}}
									</div>
								</mat-cell>
							</ng-container>

							<ng-container
								matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.COE_MOVES[0].RESIDENCY_DATE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Residency Date </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
										{{(sed.STUDENT_ELIGIBILITIES && sed.STUDENT_ELIGIBILITIES[0].CO &&
										sed.STUDENT_ELIGIBILITIES[0].CO.COE_MOVES &&
										sed.STUDENT_ELIGIBILITIES[0].CO.COE_MOVES[0].RESIDENCY_DATE) | simpleDate}}
									</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Date </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ENROLLMENT_DATE |
										simpleDate}}</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Withdrawal Date </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.WITHDRAWAL_DATE |
										simpleDate}}</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].DEPARTURE_DATE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Departure Date </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.DEPARTURE_DATE |
										simpleDate}}</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].TRACK">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Track </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.TRACK}}</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Type </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ENROLLMENT_TYPE}}
									</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ACADEMIC_RISK">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Academic Risk </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ACADEMIC_RISK}}
									</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].PFS">
								<mat-header-cell *matHeaderCellDef mat-sort-header> PFS </mat-header-cell>
								<mat-cell *matCellDef="let element" class="row"
									[ngClass]="{'selected': isSelected(element)}">
									<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.PFS}}</div>
								</mat-cell>
							</ng-container>


							<ng-container matColumnDef="CURRENT_ADDRESS.STREET_1">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Address Street 1
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_ADDRESS?.STREET_1}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_ADDRESS.STREET_2">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Address Street 2
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_ADDRESS?.STREET_2}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_ADDRESS.CITy.CITY_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Address City
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_ADDRESS?.CITy.CITY_NAME}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_ADDRESS.CITy.STATE.STATE_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Address State
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_ADDRESS?.CITy.STATE.STATE_NAME}}
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_ADDRESS.POSTAL_CODES.POSTAL_CODE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Address ZIP code
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_ADDRESS?.POSTAL_CODES.POSTAL_CODE}}
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_PHONE.PHONE_NUMBER">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Phone </mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_PHONE?.PHONE_NUMBER}}</mat-cell>
							</ng-container>


							<ng-container matColumnDef="MAILING_ADDRESS.STREET_1">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Mailing Address Street 1
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.MAILING_ADDRESS?.STREET_1}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="MAILING_ADDRESS.STREET_2">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Mailing Address Street 2
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.MAILING_ADDRESS?.STREET_2}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="MAILING_ADDRESS.CITy.CITY_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Mailing Address City
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.MAILING_ADDRESS?.CITy.CITY_NAME}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="MAILING_ADDRESS.CITy.STATE.STATE_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Mailing Address State
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.MAILING_ADDRESS?.CITy.STATE.STATE_NAME}}
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="MAILING_ADDRESS.POSTAL_CODES.POSTAL_CODE">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Mailing Address ZIP code
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.MAILING_ADDRESS?.POSTAL_CODES.POSTAL_CODE}}
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="MAILING_PHONE.PHONE_NUMBER">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Mailing Phone </mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.MAILING_PHONE?.PHONE_NUMBER}}</mat-cell>
							</ng-container>


							<ng-container matColumnDef="CURRENT_FATHER.FIRST_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Parent/Guardian 1 FN
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_FATHER?.FIRST_NAME}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_FATHER.LAST_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Parent/Guardian 1 LN
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_FATHER?.LAST_NAME}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_FATHER.EMAIL_ADDRESS">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Parent/Guardian 1 Email
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_FATHER?.EMAIL_ADDRESS}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_FATHER.PHONE_NUMBER">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Parent/Guardian 1 Phone
									Number
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_FATHER?.PHONE_NUMBER}}</mat-cell>
							</ng-container>


							<ng-container matColumnDef="CURRENT_MOTHER.FIRST_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Parent/Guardian 2 FN
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_MOTHER?.FIRST_NAME}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_MOTHER.LAST_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Parent/Guardian 2 LN
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_MOTHER?.LAST_NAME}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_MOTHER.EMAIL_ADDRESS">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Parent/Guardian 2 Email
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_MOTHER?.EMAIL_ADDRESS}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CURRENT_MOTHER.PHONE_NUMBER">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Current Parent/Guardian 2 Phone
									Number
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.CURRENT_MOTHER?.PHONE_NUMBER}}</mat-cell>
							</ng-container>


							<ng-container matColumnDef="LEGAL_FATHER.FIRST_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Legal Parent/Guardian 1 FN
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.LEGAL_FATHER?.FIRST_NAME}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="LEGAL_FATHER.LAST_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Legal Parent/Guardian 1 LN
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.LEGAL_FATHER?.LAST_NAME}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="LEGAL_FATHER.EMAIL_ADDRESS">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Legal Parent/Guardian 1 Email
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.LEGAL_FATHER?.EMAIL_ADDRESS}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="LEGAL_FATHER.PHONE_NUMBER">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Legal Parent/Guardian 1 Phone Number
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.LEGAL_FATHER?.PHONE_NUMBER}}</mat-cell>
							</ng-container>


							<ng-container matColumnDef="LEGAL_MOTHER.FIRST_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Legal Parent/Guardian 2 FN
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.LEGAL_MOTHER?.FIRST_NAME}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="LEGAL_MOTHER.LAST_NAME">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Legal Parent/Guardian 2 LN
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.LEGAL_MOTHER?.LAST_NAME}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="LEGAL_MOTHER.EMAIL_ADDRESS">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Legal Parent/Guardian 2 Email
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.LEGAL_MOTHER?.EMAIL_ADDRESS}}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="LEGAL_MOTHER.PHONE_NUMBER">
								<mat-header-cell *matHeaderCellDef mat-sort-header> Legal Parent/Guardian 2 Phone Number
								</mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'selected': isSelected(element)}">{{element.LEGAL_MOTHER?.PHONE_NUMBER}}</mat-cell>
							</ng-container>


							<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
							<mat-row *matRowDef="let row; columns: displayedColumns;"
								[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
								[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
								[matTooltipPosition]="'above'"
								[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
								[matTooltipClass]="'terminatedTooltip'"></mat-row>
						</mat-table>
					</div>
					<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
						aria-label="Select page of periodic elements"
						[hidden]="!cur.SHOW || tableDataSources[i]?.filteredData?.length === 0">
					</mat-paginator>
				</ul>
			</div>
		</div>
	</div>
</div>